import { Observable } from 'rxjs';
import { Details } from '../models/details.model';

export abstract class DetailsRepository {
    abstract toggleDetails(): Observable<Details>;
    abstract getDetails(): Observable<Details>;
}
